import React from "react";
import logo from "./assets/blockforever-logo.svg";
import { MAC_DOWNLOAD } from "./utils";

import { useNavigate } from "react-router-dom";

export default function TopNav({ scrollToSection, featuresRef, faqRef }) {
  const navigate = useNavigate();

  const downloadMac = () => {
    console.log("Running: download mac");
    window.location.href = MAC_DOWNLOAD;
  };

  return (
    <div className="topNav">
      <div className="flex-spaceBtwn">
        <div className="flex">
          <div className="flex-spaceBtwn" onClick={() => navigate("/")}>
            <span>
              <img src={logo} alt="Block Foreover logo" className="logo" />
            </span>
            <span className="ml-16 bold primaryColorText cursorPointer">
              Block Forever
            </span>
          </div>
          <div
            className="ml-32 cursorPointer"
            onClick={() => scrollToSection(featuresRef)}
          >
            Features
          </div>
          <div
            className="ml-32 cursorPointer"
            onClick={() => scrollToSection(faqRef)}
          >
            FAQ
          </div>
        </div>

        <span>
          <button className="primaryBtn" onClick={downloadMac}>
            Download Mac
          </button>
        </span>
      </div>
    </div>
  );
}
